// extracted by mini-css-extract-plugin
module.exports = {"wordGrid":"styles_wordGrid__1yUpc","gridItem":"styles_gridItem__cxVf_","allWordsGrid":"styles_allWordsGrid__3E5m_","gridAllItem":"styles_gridAllItem__2zv3w"};